import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useWealthContext } from '../../../contexts/wealth-context';
import { NavigationTabTotalWealth } from '../../../enums';
import type { IModalBalanceEntry } from '../../../interfaces/balance-sheet-table';
import { BalanceEntryModalWrapper } from '../balanceEntryModal/BalanceEntryModalWrapper';
import { AssetTable } from './accountTypes/AssetTable';
import { ExpenseTable } from './accountTypes/ExpenseTable';
import { IncomeTable } from './accountTypes/IncomeTable';
import { LiabilityTable } from './accountTypes/LiabilityTable';

export const BalanceSheet: FunctionComponent = () => {
    const { activeTab, partnerUid } = useWealthContext();
    const [showModal, setShowModal] = useState<IModalBalanceEntry | undefined>(undefined);

    const handleModalClose = () => setShowModal(undefined);

    return (
        <>
            {activeTab === NavigationTabTotalWealth.TOTAL_WEALTH && (
                <>
                    <AssetTable handleShowModal={setShowModal} />
                    <LiabilityTable handleShowModal={setShowModal} />
                    <IncomeTable handleShowModal={setShowModal} />
                    <ExpenseTable handleShowModal={setShowModal} />
                </>
            )}
            {activeTab === NavigationTabTotalWealth.ASSETS && <AssetTable handleShowModal={setShowModal} />}
            {activeTab === NavigationTabTotalWealth.LIABILITIES && <LiabilityTable handleShowModal={setShowModal} />}
            {activeTab === NavigationTabTotalWealth.INCOME_AND_EXPENSES && (
                <>
                    <IncomeTable handleShowModal={setShowModal} />
                    <ExpenseTable handleShowModal={setShowModal} />
                </>
            )}
            {!!showModal && (
                <BalanceEntryModalWrapper
                    woCategoryId={showModal.categoryId}
                    partnerUid={partnerUid}
                    balanceEntry={showModal.balanceEntry}
                    onClose={handleModalClose}
                />
            )}
        </>
    );
};
